import { AxiosError } from "axios";
import { useQuery } from "react-query";
import { ManutencaoDetalhe } from "../typings";
import http from "infra/http";

export function useManutencaoDetalhe(id?: string) {
  return useQuery<ManutencaoDetalhe, AxiosError>(
    `/v1/manutencao/${id}`,
    async () => {
      const { data } = await http.get<ManutencaoDetalhe>(
        `/v1/manutencao/${id}`
      );

      return data;
    },
    {
      enabled: !!id,
    }
  );
}
